// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/information/information.scss
 ** module id = 150
 ** module chunks = 0 1
 **/